import React from 'react'

const CustomTable = ({ headers = [], rows = [], actions = [] }) => {
  return (
    <div className='super-git-table !p-0 !m-0'>
      <table className='table-super-git !p-0'>
        <thead className='!p-0'>
          <tr className='!p-0'>
            {headers.map((header, index) => (
              <th key={index} className='!p-1 !text-sm'>
                {header}
              </th>
            ))}
            {actions.length > 0 ? (
              <th className='!p-1 !text-sm'>Actions</th>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {rows.length > 0 ? (
            rows.map((row, rowIndex) => (
              <tr key={rowIndex} className='!p-0'>
                {headers.map((header, colIndex) => (
                  <td key={colIndex} className='!p-[0.07rem] !text-sm'>
                    {row[header]}
                  </td>
                ))}
                <td className='!p-[0.07rem] !text-sm'>
                  <div className='flex gap-2 justify-center'>
                    {actions.length > 0 &&
                      actions.map((action, index) => (
                        <button
                          key={index}
                          onClick={() => action.callback(row)}
                          className='text-xl cursor-pointer'
                        >
                          {action.icon ? action.icon : action.label}
                        </button>
                      ))}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={headers.length + 1}
                className='!text-center !px-4 !py-4 !text-gray-500'
              >
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default CustomTable
